// The browser's storage quota for this origin, which the payload caches use to cap their budgets.

/** Bytes the origin may store according to `navigator.storage.estimate()`, or null when the API is missing or fails. */
export async function hsReadStorageQuota(): Promise<number | null> {
  const storage: StorageManager | undefined = globalThis.navigator?.storage;
  if (storage === undefined || typeof storage.estimate !== 'function') {
    return null;
  }
  try {
    const estimate: StorageEstimate = await storage.estimate();
    return estimate.quota !== undefined && estimate.quota > 0 ? estimate.quota : null;
  } catch {
    return null;
  }
}
